import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

//const root = ReactDOM.createRoot(document.getElementById('root'));
window.deferredPWAInstallPrompt = null;

window.addEventListener('beforeinstallprompt', (event) => {
  event.preventDefault();

  window.deferredPWAInstallPrompt = event;

  window.dispatchEvent(
    new Event('pwa-install-available')
  );
});

window.addEventListener('appinstalled', () => {
  window.deferredPWAInstallPrompt = null;

  window.dispatchEvent(
    new Event('pwa-installed')
  );
});

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();

if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        console.log('PWA Service Worker registered:', registration.scope);
      })
      .catch((error) => {
        console.error('PWA Service Worker registration failed:', error);
      });
  });
}